<template>
  <rma-pending-table :returns=returns approved />
</template>

<script>
import RmaPendingTable from './RmaPendingTable'
import shopifyService from '../../services/shopify'
import bridgeService from '../../services/bridge'

export default {
  components: {
    RmaPendingTable
  },
  data() {
    return {
      returns: [],
    }
  },
  mounted() {
    shopifyService.fetchReturnPendingReceive().then(data => {
      data.forEach(d => {
        d.returns = []
        d.source = undefined
        d.websiteName = undefined
      })
      this.returns = data
      this.returns.forEach(r => {
        bridgeService.getSalesOrder(r.name).then(o => {
          r.returns = o.data.web.returns
          r.source = o.data.web.source
          r.websiteName = o.data.web.source

          if (Array.isArray(r.returns)) {
            r.returns.forEach(x => {
              x.alert = null
            })
          }
        })
      })
    })
  },
}
</script>



// WEBPACK FOOTER //
// src/components/rma-hc/RmaPendingReceive.vue